var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGeneralDeactiveicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4935 2.5H2.82682C2.45863 2.5 2.16016 2.79848 2.16016 3.16667V6.5C2.16016 6.86819 2.45863 7.16667 2.82682 7.16667H13.4935C13.8617 7.16667 14.1602 6.86819 14.1602 6.5V3.16667C14.1602 2.79848 13.8617 2.5 13.4935 2.5Z",
    stroke: "#334155",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49349 9.83337H2.82682C2.45863 9.83337 2.16016 10.1319 2.16016 10.5V13.8334C2.16016 14.2016 2.45863 14.5 2.82682 14.5H7.49349C7.86168 14.5 8.16016 14.2016 8.16016 13.8334V10.5C8.16016 10.1319 7.86168 9.83337 7.49349 9.83337Z",
    stroke: "#334155",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4938 9.83337H11.4938C11.1256 9.83337 10.8271 10.1319 10.8271 10.5V13.8334C10.8271 14.2016 11.1256 14.5 11.4938 14.5H13.4938C13.862 14.5 14.1605 14.2016 14.1605 13.8334V10.5C14.1605 10.1319 13.862 9.83337 13.4938 9.83337Z",
    stroke: "#334155",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralDeactiveicon);
export default __webpack_public_path__ + "static/media/general-deactiveicon.bb36783ae3fac9fbaccba0d95cc4ac38.svg";
export { ForwardRef as ReactComponent };